
































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---

@Component
export default class PaymentConfirmation extends Vue {
  // used by loaders
  isLoading: boolean = false;
  checkCounter: number = 0;

  checkPaymentStatusInterval: number = 0;

  async beforeMount() {
    // this page will get called by the payfast return url
    // that means that the User has not cancelled out of payfast

    // we are not checking auth in the router here because otherwise they will be routed to the Check Router and redirected to Campaign Code immediately
    await AuthService.getLoggedInUser();
    const loggedInUser = this.$store.getters['users/loggedInUser'];   

    if (!loggedInUser.registered) {
      this.$router.push( { name: 'Register More'} );
    } else {
      // we probably got here from Payfast redirect, but even if someone hits it directly themselves, 
      // they will just hang out 30s while we make sure they havent paid and then be redirected
      // now let's hang around and wait and see if their transaction shows up as confirmed in the DB

      await this.checkPaymentStatus();
      // continue to refresh orders every minute
      this.checkPaymentStatusInterval = setInterval(() => this.checkPaymentStatus(), 10000); // 10 seconds = 1000 milliseconds * 10
    }
  }

  beforeDestroy() {
    clearInterval(this.checkPaymentStatusInterval);
  }

  async checkPaymentStatus() {
    try {

      const response = await AuthService.confirmPayment();
      this.checkCounter++;

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          // we haven't been able to confirm payment yet .... this will try again in 10s          

          if (this.checkCounter === 4) {
            // time to give up trying now
            AppService.errorHandler('We are unable to confirm your payment. Please contact Online Career Guidance Customer Support for assistance.');
            this.$router.push({ name: 'Check Register Routing' });
          }
        } else {
          // we have confirmed that payment was successful, let's send them to the TEST
          this.$router.push({ name: 'Payment Confirmed' });
        }
        
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(
          this.$store.getters['app/messages'].couldNotConnect,
        );
      }
    }
  }
  
  
}
